export default function cushionReducer(state = { ...defaultState }, action) {
  let newState = { ...state }
  switch (action.type) {
    case 'RESET_CUSHION': {
      return { ...defaultState }
    }
    case 'SET_CUSHION_TYPES': {
      const { cushionTypes } = action.payload
      newState.cushionTypes = cushionTypes
      return newState
    }
    case 'SET_CUSHION_SHAPES': {
      const { cushionShapes } = action.payload
      newState.cushionShapes = cushionShapes
      return newState
    }
    case 'SET_INITIAL_CUSHION_DIMENSIONS': {
      const { cushionDimensions } = action.payload
      newState.cushionDimensions = cushionDimensions
      newState.initialCushionDimensions = cushionDimensions
      return newState
    }
    case 'SET_CUSHION_DIMENSIONS': {
      const { cushionDimensions } = action.payload
      newState.cushionDimensions = cushionDimensions
      return newState
    }
    case 'SET_CUSHION_FILLINGS': {
      const { cushionFillings } = action.payload
      newState.cushionFillings = cushionFillings
      return newState
    }
    case 'SET_CUSHION_FASTENERS': {
      const { cushionFasteners } = action.payload
      newState.cushionFasteners = cushionFasteners
      return newState
    }
    case 'SET_CUSHION_STYLES': {
      const { cushionStyles } = action.payload
      newState.cushionStyles = cushionStyles
      return newState
    }
    case 'SET_CUSHION_SETS': {
      const { cushionSets } = action.payload
      newState.cushionSets = cushionSets
      return newState
    }
    case 'FETCH_ATTRIBUTE_TERMS_BY_ID': {
      newState.fetchingAttributeTermsByIdError = null
      newState.fetchingAttributeTermsById = true
      return newState
    }
    case 'FETCH_ATTRIBUTE_TERMS_BY_ID_SUCCESS': {
      newState.fetchingAttributeTermsById = false
      newState.fetchedAttributeTermsById = true
      return newState
    }
    case 'FETCH_ATTRIBUTE_TERMS_BY_ID_FAILURE': {
      const { error } = action.payload
      newState.fetchingAttributeTermsById = false
      newState.fetchedAttributeTermsById = false
      newState.fetchingAttributeTermsByIdError = error
      return newState
    }
    case 'SET_IS_HALF_INCH_REMOVED': {
      const { isHalfInchRemoved } = action.payload
      newState.isHalfInchRemoved = isHalfInchRemoved
      return newState
    }
    default:
      return newState
  }
}

const defaultState = {
  cushionTypes: null,
  cushionShapes: null,
  cushionDimensions: {},
  initialCushionDimensions: {},
  cushionFillings: null,
  cushionFasteners: null,
  cushionStyles: null,
  cushionSets: null,
  fetchingAttributeTermsById: null,
  fetchedAttributeTermsById: null,
  fetchingAttributeTermsByIdError: null,
  isHalfInchRemoved: false,
}
